<aside class="flex h-screen flex-col overflow-y-auto bg-neutral-950 px-4 py-5 text-neutral-400">
    <a
        routerLink="/"
        class="mb-8 flex justify-center px-2 py-2">
        <img
            class="h-10 w-auto object-contain"
            src="images/logo.png"
            alt="Playbrew" />
    </a>

    <div class="mb-6">
        <div class="relative mt-2">
            <select
                #regionSelect
                class="w-full appearance-none rounded-lg border border-neutral-700 bg-neutral-900 py-3 pl-3 pr-12 text-base text-white"
                (change)="regionService.selectRegion(regionSelect.value)">
                @for (region of regionService.regions(); track region.id) {
                    <option [value]="region.id" [selected]="region.id === regionService.selectedRegion().id">{{ region.label }}</option>
                }
            </select>
        </div>
    </div>

    <nav aria-label="Main navigation">
        <ul class="space-y-1">
            @for (item of items(); track item.title) {
                <li>
                    <a
                            [routerLink]="item.route"
                            routerLinkActive="bg-white text-neutral-950 shadow-sm"
                            class="group flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors hover:bg-neutral-800 hover:text-white">
                        <mat-icon
                                class="size-5 text-[20px] text-neutral-500 group-hover:text-neutral-300"
                                aria-hidden="true">{{ item.icon }}</mat-icon>
                        <span>{{ item.title }}</span>
                    </a> 
                </li>
            }
        </ul>
    </nav>

    <div class="mt-auto border-t border-neutral-800 pt-4">
        <a
            href="/account/logout"
            class="flex w-full items-center justify-center rounded-lg border border-neutral-700 px-3 py-2 text-sm font-medium text-neutral-300 transition-colors hover:border-neutral-500 hover:bg-neutral-900 hover:text-white"
            (click)="logout()">
            Log out
        </a>
    </div>
</aside>
